import _get from 'lodash/get';

import { Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { DataLayerTransformer, inventoryTransformer: PixallInventoryTransformer } = PixallTransformers;

/**
 *
 * @summary Pixall impression for tracking dealer segmentation
 */
export function dealerSegmentationImpression(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
        history,
    } = metadata;
    const { inventoryId } = data;
    const { brand } = state;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const ecommWebsite = _get(inventory, 'ecommWebsite', {});
    const isAccelerate = _get(inventory, 'paymentServices.digitalRetailingType', '') === 'accelerate';
    const isEsntial = !!_get(inventory, 'esntial', false);
    const isEcommWebsite = !!Object.keys(ecommWebsite).length;
    const isPrivateSeller = inventory?.owner?.privateSeller;
    const pageId = DataLayerTransformer.getPageId(dataLayer);
    const clickType = _get(state, 'query.clickType', '');

    let cmp = 'at-kbb';

    if (isAccelerate && isEsntial) {
        cmp = 'accelerate-esntial';
    } else if (isAccelerate) {
        cmp = 'accelerate';
    } else if (isEsntial) {
        cmp = 'esntial';
    } else if (isEcommWebsite) {
        cmp = 'at-kbb-ecomm';
    }

    let program = 'DealerDotCom';
    switch (brand) {
        case 'ford':
            program = 'atfordcpo';
            break;
        case 'carAndDriver':
            program = 'caranddriver';
            break;
        default:
            break;
    }

    const payload = {
        program,
        eventSource: brand === 'kbb' ? 'directions' : 'dealership',
        label: cmp,
        pageId,
        vehicleType: (inventory?.listingType || '').toUpperCase(),
        ...PixallInventoryTransformer.getInventoryData(inventory),
        clickType: clickType || inventory?.clickType,
        ...(isPrivateSeller && {
            feature: 'private-seller',
            listingType: 'pvt',
            pageId: 'fyc_psx_vdp',
        }),
    };

    Pixall.sendImpression({ dataLayer, history }, payload, option);

    return { cmp };
}
